import { render, staticRenderFns } from "./poiConfiguration.vue?vue&type=template&id=47b04cfa&"
import script from "./poiConfiguration.vue?vue&type=script&lang=js&"
export * from "./poiConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./poiConfiguration.vue?vue&type=style&index=0&id=47b04cfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports